export default {"src":"/polygon/_next/static/media/angels.c9ffd091.svg","height":25,"width":25};